import React from "react";
import RichTextRenderer from "../common/RichTextRenderer";
import Info from "./Info";

const getMediaUrl = (media) => {
  if (!media) return null;
  if (Array.isArray(media)) {
    return media[0]?.url || null;
  }
  return media.url || null;
};

const SpecialNewsLayout = ({ newsletter }) => {
  if (!newsletter) return null;

  const {
    title,
    subtitle,
    banner_img,
    content,
    img_title,
    img,
    img_link,
    info_title,
    info_img,
    download_pdf,
    slogan,
    facebook_text,
    facebook_img,
    facebook_url,
    facebook_share_url,
    info,
    footer,
  } = newsletter;

  const bannerImgUrl = getMediaUrl(banner_img);
  const mainImgUrl = getMediaUrl(img);

  const hasImgLinkRichText =
    Array.isArray(img_link) && img_link.length > 0;
  const hasImgLinkLegacyUrl =
    typeof img_link === "string" && img_link.trim().length > 0;

  // Prefer nested `info` component if available, otherwise fallback to flat fields
  const infoData =
    info ||
    {
      info_title,
      info_img,
      download_pdf,
      slogan,
      facebook_text,
      facebook_img,
      facebook_url,
      facebook_share_url,
    };

  return (
    <div className="bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl p-6 sm:p-8 lg:p-10 space-y-8">
      {/* Two-column main content: left (main) + right (info) */}
      <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-8 lg:gap-10 items-start">
        {/* Left Column */}
        <div className="space-y-6">
          {/* Title + Subtitle */}
          {(title || subtitle) && (
            <div className="space-y-2">
              {title && (
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 leading-tight">
                  {title}
                </h1>
              )}
              {subtitle && (
                <p className="text-base sm:text-lg text-gray-600">
                  {subtitle}
                </p>
              )}
            </div>
          )}

          {/* Banner Image */}
          {bannerImgUrl && (
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src={bannerImgUrl}
                alt={title || "Banner"}
                className="w-full h-auto object-cover"
              />
            </div>
          )}

          {/* Main Rich Content */}
          {content && Array.isArray(content) && content.length > 0 && (
            <div className="bg-white rounded-2xl border border-gray-100 shadow-md p-5 sm:p-6 md:p-7">
              <div className="prose prose-lg max-w-none text-gray-800">
                <RichTextRenderer
                  content={content}
                  textColorClass="text-black"
                  linkColorClass="text-blue-600 hover:text-blue-800 underline text-lg lg:text-xl"
                />
              </div>
            </div>
          )}

          {/* Image Title + Image + img_link (rich text blocks) */}
          {(img_title ||
            mainImgUrl ||
            hasImgLinkRichText ||
            hasImgLinkLegacyUrl) && (
            <div className="bg-white rounded-2xl border border-gray-100 shadow-md p-5 sm:p-6 md:p-7 space-y-4">
              {img_title && (
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
                  {img_title}
                </h2>
              )}

              {mainImgUrl && (
                <div className="rounded-2xl overflow-hidden shadow-md">
                  <img
                    src={mainImgUrl}
                    alt={img_title || title || "Image"}
                    className="w-full h-auto object-contain bg-white"
                  />
                </div>
              )}

              {hasImgLinkRichText && (
                <div className="prose prose-lg max-w-none text-gray-800">
                  <RichTextRenderer
                    content={img_link}
                    textColorClass="text-black"
                    linkColorClass="text-blue-600 hover:text-blue-800 underline text-lg lg:text-xl"
                  />
                </div>
              )}
              {!hasImgLinkRichText && hasImgLinkLegacyUrl && (
                <div className="prose prose-lg max-w-none text-gray-800">
                  <p>
                    <a
                      href={img_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-800 underline text-lg lg:text-xl"
                    >
                      Open link
                    </a>
                  </p>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Right Column - Info Component */}
        <div>
          <Info info={infoData} />
        </div>
      </div>

      {/* Footer (rich text) inside the same newsletter container
      {footer && (
        <div className="border-t border-gray-100 pt-6">
          <div className="prose prose-lg max-w-none text-gray-800">
            {Array.isArray(footer) ? (
              <RichTextRenderer
                content={footer}
                textColorClass="text-black"
                linkColorClass="text-blue-600 hover:text-blue-800 underline text-lg lg:text-xl"
              />
            ) : (
              <p>{footer}</p>
            )}
          </div>
        </div>
      )} */}
    </div>
  );
};

export default SpecialNewsLayout;


